// permiso.guard.ts
import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { from, map, Observable, of, switchMap } from 'rxjs';
import { SessionService } from '@core/services/session.service';

export const permisoCanMatch: CanMatchFn = (route): Observable<boolean | UrlTree> => {
    const sessionService = inject(SessionService);
    const router = inject(Router);
    const accion = route.data?.['accion'] as string;

    if (!accion) {
        return of(false);
    }

    return from(sessionService.hydrateSessionContext()).pipe(
        switchMap(() => sessionService.tieneAcceso(accion)),
        map(ok => ok || router.createUrlTree(['']))
    );
};
